const Images = document.querySelectorAll('.ctn_img .img');
const root = document.querySelector('.ctn_scroll_info');
const sections = document.querySelectorAll('.scroll_section');
const sentinels = document.querySelectorAll('.scroll_section .sentinel');

sentinels.forEach((el, i) => el.dataset.idx = i);

const visibleState = new WeakMap();

function setActive(index) {
  if (!Images[index]) return;
  Images.forEach(img => img.classList.remove('active'));
  sections.forEach(sec => sec.classList.remove('active'));
  Images[index].classList.add('active');
  const sec = sections[index];
  if (sec) sec.classList.add('active');
}

function setActiveByVisible() {
  // Sentinels visibles
  const visibles = [...sentinels].filter(s => visibleState.get(s));
  if (visibles.length) {
    // El más “abajo” en el contenedor (mayor top)
    const target = visibles.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top).pop();
    setActive(Number(target.dataset.idx));
    return;
  }
  // Fallback: elegir el sentinel cuyo top es el primero mayor que el scroll actual
  const scrollTop = root ? root.scrollTop : window.scrollY;
  const list = [...sentinels].sort((a, b) => a.offsetTop - b.offsetTop);
  let candidate = list.find(s => s.offsetTop >= scrollTop) || list[0];
  if (candidate) setActive(Number(candidate.dataset.idx));
}

function onIntersect(entries) {
  entries.forEach(entry => {
    const prev = visibleState.get(entry.target) || false;
    const now = entry.isIntersecting;
    if (prev !== now) {
      visibleState.set(entry.target, now);
    }
  });
  setActiveByVisible();
}

const observer = new IntersectionObserver(onIntersect, {
  root: root,
  rootMargin: '0px',
  threshold: 0
});

sentinels.forEach(el => observer.observe(el));

// Inicial
setActiveByVisible();